const ADD_FILTER = "ADD_FILTER"
const REMOVE_FILTER = "REMOVE_FILTER"

export { ADD_FILTER, REMOVE_FILTER }
